export default {
  home: 'خانه',
  myLoads: 'بارهای‌من',
  loadSteps: 'مراحل حمل بار',
  loadDetail: 'جزئیات بار',
  allLoads: {
    assigned: 'بارهای تخصیص یافته',
    current: 'بارهای جاری',
    discharged: 'بارهای تخلیه شده'
  },
  dashboard: 'داشبورد',
  account: 'حساب کاربری',
  editAccount: 'ویرایش حساب کاربری',
  loadOffers: 'پیشنهادات بار',
  changePassword: 'تغییر رمز عبور',
  createPassword: 'ساخت رمز عبور',
  myBankAccounts: 'حساب های بانکی من',
  addBankAccounts: 'افزودن حساب بانکی',
  activeSessions: 'نشست های فعال',
  loadDischarge: 'تخلیه بار',
  commercialBanking: 'بانکداری تجاری',
  myPayments: 'پرداختی های من',
  wallet: 'کیف پول',
  credentials: 'مدارک',
  contract: 'قرارداد'
}
